import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllProfessionalsUseCaseInterface } from 'domain/usecases';
import { getProfileKey } from 'domain/value-objects/profile-type';

export class RemoteGetAllProfessionals
  implements GetAllProfessionalsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllProfessionalsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllProfessionalsUseCaseInterface.Params,
  ): Promise<GetAllProfessionalsUseCaseInterface.Result> {
    const { profileType, page, length, ...restParams } = params;

    const requestUrl = `${this.url}/${getProfileKey(profileType)}/${page}/${length}`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams as any),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
